import type {
	ExportProducaoOfflineConfig,
	OfflineServiceId,
} from "./exportProducaoOfflineConfig";

/**
 * Infere serviço offline a partir do token material e regras materialInference.
 * Todas as strings em match devem aparecer no material normalizado.
 */
export function inferOfflineService(
	material: string,
	config: ExportProducaoOfflineConfig,
): OfflineServiceId | null {
	const normalized = material.toLowerCase().replace(/[^a-z0-9]/g, "");
	if (!normalized) return null;

	for (const rule of config.materialInference) {
		const allMatch = rule.match.every((token) =>
			normalized.includes(token.toLowerCase()),
		);
		if (allMatch) return rule.serviceId;
	}

	return null;
}

export function getServiceFolder(
	serviceId: OfflineServiceId,
	config: ExportProducaoOfflineConfig,
): string {
	return config.services[serviceId]?.folder ?? serviceId;
}
